import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DetalleEstablecimientoService } from '../../funcionario/opciones/establecimiento/establecimiento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { DetalleSolicitudPrestadorService } from './detalle-solicitud.service';

@Component({
	selector: 'app-detalle-solicitud',
	templateUrl: './detalle-solicitud.component.html',
	styleUrls: ['./detalle-solicitud.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DetalleSolicitudPrestadorComponent implements OnInit {
	estados: Array<any>;
	comentarios: Array<any>;
	descripcion: any;
	key: string;
	// informacion establecimiento
	informacionEstablecimiento: any;
	constructor(private detalleSolicitudPrestadorService: DetalleSolicitudPrestadorService,
		activedRoute: ActivatedRoute, private router: Router, private dataSharedService: DataSharedService) {
		this.informacionEstablecimiento = {};
		this.key = activedRoute.snapshot.paramMap.get('key');
		if (!this.key) {
			router.navigate(['/login']);
		}
	}

	ngOnInit() {
		this.detalleSolicitudPrestadorService.getDetalleEstablecimiento(this.key).subscribe(res => {
			if (res.result) {
				this.informacionEstablecimiento = res.data;
				this.dataSharedService.sharedData(this.informacionEstablecimiento);
				this.router.navigate([`/detalle-consulta-solicitud/${this.key}/establecimientos`]);
			}
		});
	}



}
